import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusLabelComponent } from './status-label.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { IconModule } from '@certemy/ui-components';

@NgModule({
  imports: [CommonModule, NgbTooltipModule, IconModule],
  exports: [StatusLabelComponent],
  declarations: [StatusLabelComponent],
  providers: [],
})
export class StatusLabelModule {}
